<template>
  <div class="accordion">
    <div class="header cor-principal noselect" @click="toggle">
      <unicom-icone class="header-icon" :nome="nomeIcone" :tamanho="20" />
      <slot name="header"></slot>
    </div>
    <transition
      name="accordion"
      @before-enter="beforeEnter"
      @enter="enter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <div ref="body" class="body" v-show="show">
        <div ref="body-inner" class="body-inner">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      show: false
    };
  },

  methods: {
    toggle: function() {
      this.show = !this.show;
    },
    beforeEnter: function(el) {
      el.style.height = "0";
    },
    enter: function(el) {
      el.style.height = el.scrollHeight + "px";
    },
    beforeLeave: function(el) {
      el.style.height = el.scrollHeight + "px";
    },
    leave: function(el) {
      el.style.height = "0";
    },
    resetarAltura() {
      if ([undefined, null].includes(this.$refs.body)) return;

      this.$refs.body.style.height =
        this.$refs["body-inner"].scrollHeight + "px";
    }
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.resetarAltura();
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.resetarAltura());
  },
  computed: {
    nomeIcone() {
      return this.show ? "minus-square" : "plus-square";
    }
  },
  watch: {
    value() {
      this.show = this.value;
    },
    show() {
      this.$emit("input", this.show);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./Accordion";
</style>
